module.exports = __webpack_public_path__ + "static/media/clean.pass.blue.9c397dc7.png";